class VideoPlayer {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.videos = document.querySelectorAll('.videoPlayer__video')

    if (!this.videos.length)
      return false

    this.buttons   = document.querySelectorAll('.videoPlayer__play')
    this.length    = this.videos.length
    this.players   = []
    this.lockClick = false

    return true

  }

  setEvents() {

    window.addEventListener('load', () => { this.loadYouTubeApi() })

  }

  loadYouTubeApi() {

    let tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/player_api'
    let firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    window.onYouTubeIframeAPIReady = () => {

      this.bindOpenAction()

    }

  }

  bindOpenAction() {

    let length = this.buttons.length
    for (let i = 0; i < this.length; i++) {

      this.buttons[i].addEventListener('click', (e) => {

        e.preventDefault()

        if (this.lockClick)
          return

        this.playVideo(i)
        e.currentTarget.addClass('videoPlayer__play--loading')
        this.current = i

      })
    }

  }

  playVideo(index) {

    this.lockClick = true

    let playAction = (event) => {

      this.players.slice(-1)[0].playVideo()
      setTimeout(() => { this.buttons[index].parentNode.addClass('videoPlayer__overlay--hidden') }, 0)

    }

    let changeAction = (event) => {

      if (event.data != YT.PlayerState.PLAYING)
        return

      this.lockClick = false

      let length = this.players.length
      for (let i = 0; i < length; i++) {

        if (this.players[i].a != event.target.a)
          this.players[i].pauseVideo()

      }

    }

    this.players.push(

      new YT.Player(this.videos[index], {
        videoId    : this.videos[index].getAttribute('data-youtube'),
        playerVars : {
          'controls' : 2,
          'rel'      : 0,
          'showinfo' : 0,
          'loop'     : 1,
          'origin'   : window.location.protocol + '//' + window.location.hostname,
        },
        events     : {
          'onReady'       : playAction,
          'onStateChange' : changeAction
        }
      })

    )

  }

}